/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/loot_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M13 15.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z"/><path pid="1" d="M11 10.5h.5V10a.5.5 0 011 0v.5h.5a.5.5 0 010 1h-.5v.5a.5.5 0 01-1 0v-.5H11a.5.5 0 010-1zm2 13c-2.481 0-4.5-2.02-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.02 4.5 4.5-2.019 4.5-4.5 4.5zm6 1h-.5v.5c0 .275-.225.5-.5.5s-.5-.225-.5-.5v-.5H17c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h.5V23c0-.275.225-.5.5-.5s.5.225.5.5v.5h.5c.275 0 .5.225.5.5s-.225.5-.5.5zm3-11h-3.5V10a.5.5 0 011 0v1.793L24 7.25l.75.75-4.543 4.5H22a.5.5 0 010 1z"/>'
  }
})
